import React from 'react';
import { Flex, Box, flameTheme } from '@lightspeed/flame/Core';
import { Text } from '@lightspeed/flame/Text';
import { Tooltip } from '@lightspeed/flame/Tooltip';
import { Button } from '@lightspeed/flame/Button';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Input } from '@lightspeed/flame/Input';
import { InputGroup } from '@lightspeed/flame/InputGroup';

interface CopyLinkProps {
  url: string;
}

const CopyLink: React.FC<CopyLinkProps> = ({ url }) => {
  const [isCopied, setIsCopied] = React.useState(false);
  const { colors } = flameTheme;
  const tooltipContent = isCopied ? 'Copied!' : 'Copy to clipboard';

  return (
    <Flex flexDirection="column" justifyContent="center" alignItems="center">
      <Text fontWeight="bold">Copy the link</Text>
      <Box width="100%">
        <CopyToClipboard text={url} onCopy={() => setIsCopied(true)}>
          <InputGroup mt={3} mb={3}>
            <Input readOnly value={url} onChange={() => {}} />
            <Button>
              <Tooltip content={tooltipContent}>Copy</Tooltip>
            </Button>
          </InputGroup>
        </CopyToClipboard>
      </Box>
      <Box p={3} pt={1}>
        <Text size="small" textAlign="center" color={colors.textDimmed}>
          Paste in a new browser window or on a secondary display.
        </Text>
      </Box>
    </Flex>
  );
};

export { CopyLink };
